import { d as dayjs } from './dayjs.min-33ec49a4.js';

/**
 * Checks if value is an empty object, collection, map, or set.
 *
 * @param {any} value - The value to check.
 * @return {Boolean} True if value is empty, else False.
 */
const isEmpty = (value) => value ? [Object, Array].includes(value.constructor) && !Object.entries(value).length : true;

const LANGUAGES = {
    EN: 'EN',
    FR: 'FR',
    DE: 'DE',
    ES: 'ES',
    PT: 'PT',
    IT: 'IT',
    RU: 'RU',
    JA: 'JA',
    ZH: 'ZH',
    HU: 'HU',
    RO: 'RO',
    DA: 'DA',
    NL: 'NL',
    AZ: 'AZ',
};

const getLanguage = () => {
    const locale = dayjs.locale();
    return locale.toUpperCase();
};
/**
 * Hydrates the a Translatable entity with the translations for that specific language
 *
 * @param {Object} obj - Translation object
 * @param {string} ln - String language
 * @return {Translated}
 */
const translateEntity = (obj, ln = getLanguage()) => {
    if (!obj)
        return obj;
    const result = { ...obj };
    if (result?.translations) {
        for (const key in result.translations) {
            if (result.translations[key][ln]) {
                result[key] = result.translations[key][ln];
            }
            else if (result.translations[key].EN) {
                result[key] = result.translations[key].EN;
            }
        }
    }
    return result;
};

export { LANGUAGES as L, getLanguage as g, isEmpty as i, translateEntity as t };

//# sourceMappingURL=translation-2f019693.js.map